import { Inject, Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from "@angular/common/http";
import { ConfigParam } from "./config-param.model";
import { getFullUrl } from "../../shared/utils/url";
import { catchError, lastValueFrom, map, of } from "rxjs";
import { ConfigParamsResponse } from "./config-params-response.model";
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigParamService {
  private http: HttpClient;
  private configParams: ConfigParam[] = [];

  constructor(
    handler: HttpBackend,
  ) {
    // Prevents the interceptors from intercepting requests made by this service
    // Against error handling on app initialization
    this.http = new HttpClient(handler);
  }

  public loadConfig(): Promise<void> {
    const fullUrl = getFullUrl(environment.guiBackendRootEndpoint, 'config-params');
    return lastValueFrom(this.http.get<ConfigParamsResponse>(fullUrl).pipe(
      map((configParamsResponse: ConfigParamsResponse) => {
        this.configParams = configParamsResponse.configParams;
      }),
      catchError(() => {
        console.error("Error loading config params");
        return of();
      })
    ))
  }

  public getConfigParamByParamName(paramName: string): ConfigParam | undefined {
    const configParam = this.configParams.find(x => x.paramName === paramName);
    if (configParam === undefined) {
      console.error(`${paramName} is undefined`);
    }
    return configParam;
  }
}
